// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__agPyN","colMin":"styles_colMin__1JPO0","colCheckbox":"styles_colCheckbox__2c6CQ"};